<template>
  <a :class="$style.button" href="#main">
    {{ storeTranslations.translations?.['skipLink.label'] || 'skip to main content' }}
  </a>
</template>

<script lang="ts">
import { useStoreTranslations } from '../../../../store/translations/translations';
</script>

<script setup lang="ts">
const storeTranslations = useStoreTranslations();
</script>

<style module lang="scss">
@forward './SkipLink.scss';
</style>
